import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Label, LabelData } from '../../../components/labels/lib/entities';
import { ResourcePath } from '../../../hooks/resource-path';
import { QueryKey } from '../../../lib/query-key';

export interface NewLabelArgs {
	name: string;
}

interface UseCreateLabelsOptions {
	onSuccess?: (response: any) => void;
}

export const useCreateLabels = (options: UseCreateLabelsOptions = {}) => {
	const http = useHttpClient('v2');
	const queryClient = useQueryClient();

	return useMutation(async (args: NewLabelArgs) => {
		const response = await http.post<LabelData>(ResourcePath.Labels, {
			name: args.name,
		});
		queryClient.invalidateQueries([QueryKey.Labels]);
		return new Label(response.data);
	}, options);
};
